module.exports = __webpack_public_path__ + "img/work_outline_black_24dp.80cede38.svg";